import React, { Component } from 'react';
import "./App.css";
import Movie from './Movie';


class App extends Component {
    state = {}
    // Render: componentWillMount() -> render() -> componentDidMount()

    // Update componentWillMount() -> shouldComponentUpdate() -> componentWillUpdate() -> render() -> component

    // component life cycle in a different order


    //do not mutate state directly !!!!! use setState

    componentDidMount(){
        this._getMovies();
    }
    _renderMovies = () => {
        const movies = this.state.movies.map((movie) => {
            console.log(movie);
            return <Movie
                title={movie.title_english}
                poster={movie.medium_cover_image}
                key={movie.id}
                genres={movie.genres}
                synopsis={movie.synopsis}
            />
        });
        return movies
    }

    // async await (until the await function is done, next step does not happen)
    _getMovies = async () => {
        const movies = await this._callApi();
        this.setState({
            movies
        })
    }

    _callApi = () => {
        return fetch('https://yts.am/api/v2/list_movies.json?sort_by=download_count')
            .then(response => response.json())
            .then(json => json.data.movies)
            .catch(err => console.log(err))
    }
    //second
  render() {
        const { movies } = this.state;
    return (
        /**
         * jsx
         * do not repeat components
         */
      <div className={movies ? "App" : "App--loading"}>
        {movies ? this._renderMovies() : 'Loading'}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js